import React from "react";

import styles from "./styles/Layout.module.scss";
import { Col, Row, Spinner } from "react-bootstrap";
import ChatThreads from "./ChatThreads";
import Inbox from "./Inbox";
import { useChatContext } from "./Context/ChatContext";
import _ from "lodash";

export default function DesktopLayout({ setUser }) {
  const { chatRoom } = useChatContext();
  return (
    <div className={styles.Layout}>
      <Row className={styles.row}>
        <Col className={styles.col} md={4}>
          <ChatThreads setUser={setUser} />
        </Col>
        <Col className={styles.col} md={8}>
          {!_.isEmpty(chatRoom) ? (
            <Inbox key={chatRoom.slug} />
          ) : (
            <div className="w-100 h-100 d-flex align-items-center justify-content-center">
              <p className={styles.emptyText}>
                Select a chat to start messaging
              </p>
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
}
